import useMetaTags from '../../hooks/useMetaTags';
import { BenefitSection, LargeData, roleWriting, AssistanceSection, FAQ } from '../../Data/All_Services_Data/shopifyDevelopmentServicesData';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Handle_Largedata_section from '../../component/Services_Component/Handle_Largedata_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const ShopifyDevelopmentServices = () => {
  useMetaTags({
    title:
      "Custom Shopify Development Services | Warrgyizmorsch Experts",
    description:
      "Warrgyizmorsch provides end-to-end Shopify development services to build, scale, and optimize your eCommerce store. Get custom solutions that drive online growth.",
    keywords:
      "shopify development services, shopify web development company, shopify developers, shopify web design, shopify website development, shopify development company, shopify web development, shopify website development company, shopify application development", });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Shopify Development Services
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/shopify.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  Warrgyizmorsch brings you high-quality Shopify development services focused on speed, growth, and visual style. If you start a new online shop or want to switch from other platforms, we create Shopify solutions that are dependable, easy to use, and optimized for turning visitors into buyers. As a company providing complete Shopify web development, our goal is to give your business a seamless and flexible online store. With skilled Shopify developers on our team, your store becomes fast, safe, and attractive-built for future success.
                </p>
              </div>
            </div>

            <Benefits_section data={BenefitSection} />

            <Handle_Largedata_section LargeData={LargeData} />

            <Role_writing data={roleWriting} />

            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  )
}

export default ShopifyDevelopmentServices